var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"CourseSideBar"}},[_c('Tabs',{ref:"tabs",model:{value:(_vm.tabValue),callback:function ($$v) {_vm.tabValue=$$v},expression:"tabValue"}},[_c('TabPane',{attrs:{"label":"视频","name":"video"}},[(_vm.tabValue === 'video')?_c('CourseVideos',{attrs:{"course":_vm.course,"videos":_vm.videos}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }